// ShareMode tab — Real implementation (F-06 Phase B).
// Replaces F-01 placeholder. Empty state saat belum ada project; otherwise
// mount ShareModal (QR + copy + privacy). Confirm opt-in dipanggil di parent
// (App.js handleShare) — di sini kita asumsikan consent sudah diberikan.

import { STRINGS } from '@tm/shared'
import { mountShareModal } from '../share/ShareModal.js'
import { estimateUrlSize, SHARE_URL_MAX_BYTES } from '../share/encode.js'
import { trackEvent } from '../analytics/plausible.js'

export function createShareMode({ project, onShareEvent } = {}) {
  const el = document.createElement('section')
  el.className = 'tm-mode tm-share'
  el.setAttribute('role', 'tabpanel')
  el.setAttribute('aria-label', STRINGS.modeShare)

  if (!project) {
    el.innerHTML = `
      <div class="tm-mode__icon" aria-hidden="true">🔗</div>
      <h2 class="tm-mode__title">${STRINGS.shareEmptyTitle}</h2>
      <p class="tm-mode__body">${STRINGS.shareEmptyBody}</p>
    `
    return el
  }

  const urlSize = estimateUrlSize(project)
  const tooLong = urlSize > SHARE_URL_MAX_BYTES
  const sizeKb = Math.round(urlSize / 1024)
  const maxKb = Math.round(SHARE_URL_MAX_BYTES / 1024)

  el.innerHTML = `
    <div class="tm-mode__icon" aria-hidden="true">🔗</div>
    <h2 class="tm-mode__title">${STRINGS.shareModalTitle}</h2>
    <p class="tm-mode__body">${STRINGS.shareModalDesc}</p>
    <p class="tm-mode__meta">${STRINGS.playPageTitle
      .replace('%s', project.name || 'Anonim')
      .replace('🎮 ', '📄 ')} · ${sizeKb} KB / max ${maxKb} KB</p>
    <div class="tm-mode__actions">
      <button class="tm-btn-primary tm-share-mode__open" type="button" data-tm-action="open-share">
        ${STRINGS.shareCopyLink}
      </button>
      <p class="tm-mode__body tm-mode__privacy">${STRINGS.sharePrivacyNotice}</p>
      ${tooLong ? `<p class="tm-mode__body tm-mode__error">${STRINGS.shareUrlTooLong}</p>` : ''}
    </div>
  `

  const openBtn = el.querySelector('[data-tm-action="open-share"]')
  if (openBtn && !tooLong) {
    openBtn.addEventListener('click', async () => {
      trackEvent('share_modal_opened', { projectId: project.id })
      const { url } = await mountShareModal({ project })
      if (url) {
        trackEvent('share_link_generated', {
          projectId: project.id,
          projectSizeBytes: urlSize,
        })
        if (typeof onShareEvent === 'function') {
          onShareEvent({ type: 'share_link_generated', url })
        }
      }
    })
  } else if (openBtn) {
    openBtn.disabled = true
    openBtn.setAttribute('aria-disabled', 'true')
  }

  return el
}
